module.exports = __webpack_public_path__ + "static/img/oprCt_bg_white_04.2087362e.svg";